import { gql } from "@apollo/client";

export const UPDATE_TEMPLATE_MASKS = gql`
  mutation updateTemplateMasks(
    $templateId: String
    $clientIdentifier: String
    $input: [TemplateMaskInput!]!
  ) {
    invoiceInterpretation {
      updateTemplateMasks(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        input: $input
      ) {
        success
      }
    }
  }
`;